import React, { useEffect } from 'react';
import { Route, Switch, useLocation } from 'react-router';
import { PrivateRoute } from '../components/_helpers/PrivateRoute';
import Login from '../components/authentication/Login';
import Invite from '../components/authentication/Invite';
import Home from '../components/Home';
import Platform from '../components/group/Platform';
import Application from '../components/platform/Application';
import Company from '../components/company/Company';
import PlatformDashboardComponent from '../components/group/PlatformDashboardComponent';
import UserComponent from '../components/user/UserComponent';
import CompanyDashboardComponent from '../components/company/CompanyDashboardComponent';
import PlatformComponent from '../components/group/PlatformComponent';
import EditCitizenComponent from '../components/citizen/EditCitizenComponent';
import CallbackComponent from '../components/config/CallbackComponent';
import LogoutComponent from '../components/authentication/Logout';
import UserSupportComponent from '../components/user/UserSupportComponent';
import UserRegistration from '../components/user/UserRegistration';
import FeedTask from 'components/FeedTask/FeedTask.view';
import UserApplications from '../presentations/view/UserApplications/UserApplications.view';
import ClientSystemDownload from '../presentations/view/ClientSystemDownload/ClientSystemDownload.view';
import ClientSystemDownloadSCG from '../presentations/view/ClientSystemDownloadSCG/ClientSystemDownloadSCG.view';
import AssignRoleProfile from '../presentations/view/AssignRoleProfile/AssignRoleProfile.view';

// import Dashboard from '../components/dashboard/Dashboard'; // Deprecated
import Dashboard from '../common/components/Dashboard';
import UserVerification from '../presentations/view/UserVerification/UserVerification.view';
import SandboxRegister from '../presentations/view/SandboxRegister/SandboxRegister.view';
import NewTask from '../presentations/view/NewTask/NewTask.view';
// import UserVerification from '../components/user/UserVerification';
import Logs from '../presentations/view/Logs/Logs.view';
import ingress from '../components/authentication/ingress';
import LineConnectView from 'components/LineConnect/LineConnect.View';
import Profile from 'components/Profile/Profile.view';
import UserDashboardComponent from 'components/user/UserDashboardComponentMain';
import TicketView from 'presentations/view/Ticket/Ticket.view';
import AssignEmployee from 'presentations/view/AssignEmployee/AssignEmployee.view';
import AuthenticationHistoryLogs from 'presentations/view/AuthenticationHistory/AuthenticationHistory.view';
import ApplicationHistory from 'presentations/view/ApplicationHistory/ApplicationHistory.view';
import PasswordManagement from 'presentations/view/PasswordManagement/PasswordManagement.view';
import PrivacyConfig from 'presentations/view/PrivacyConfig/PrivacyConfig.view';
import FguiPortManagement from 'presentations/view/FguiPortManagement/FguiPortManagement.view';
import { isValidURL } from '../common/helpers';
import { GetTokenResponse } from 'models/authentication/Authentication';
import { getTokenWithWebId } from '../data/token/datasources/token.datasource';
import { observer } from 'mobx-react';
import { useLoader, useStore } from '../common/hooks';
import { NotFound } from '../presentations/view/NotFound/NotFound';
import { PasswordExpiryWarning } from '../models/authentication/PasswordExpiryWarning';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router';
import { UserAuthentication } from '../presentations/view/UserAuthentication/UserAuthentication';
import { useQuery } from '@tanstack/react-query';
import { useCheckPasswordStatus } from '../queries';
//import { RequireChangePasswordFormModal } from '../common/components';
import { useBoolean } from '@chakra-ui/react';
// import FeedTask from '../presentations/view/FeedTask/FeedTask.view';

const Layout = observer(() => {
    const { userCompanyStore } = useStore();
    const { citizenId, email, firstName, lastName } = userCompanyStore;

    const location = useLocation();
    const history = useHistory();

    const loader = useLoader();

    //const [isOpenRequireChangePasswordFormModal, setIsOpenRequireChangePasswordFormModal] =
    //    useBoolean();

    //const { error } = useCheckPasswordStatus({ citizenId });
    //useEffect(() => {
    //    if (!error) {
    //        return;
    //    }

    //    if (error.response?.status === 401) {
    //        setIsOpenRequireChangePasswordFormModal.on();
    //    }
    //}, [error]);

    // Redirect params interceptor
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const [token, mode, redirectToApp, webId] = [
            'token',
            'mode',
            'redirect_to_app',
            'web_id'
        ].map(key => searchParams.get(key));

        // Save `redirect_to_app` to session storage for generate token and redirect after login
        if (redirectToApp && webId) {
            sessionStorage.setItem('redirect_to_app', redirectToApp);
            sessionStorage.setItem('web_id', webId);
        }
    }, []);

    // If `redirect_to_app` exists in session storage, generate a token and redirect to the application
    useEffect(() => {
        // TODO: Wrap try-catch-finally and clear the session

        if (!citizenId) return;

        try {
            loader.show();

            const rawRedirectUrl = sessionStorage.getItem('redirect_to_app');
            const webId = sessionStorage.getItem('web_id');

            // @ts-ignore
            if (!rawRedirectUrl || !isValidURL(rawRedirectUrl) || !webId) {
                throw void 0;
            }

            const redirectUrl = new URL(decodeURI(rawRedirectUrl));

            (async () => {
                const response = await getTokenWithWebId({
                    web_id: webId,
                    url: redirectUrl.origin,
                    citizen_id: citizenId,
                    email,
                    first_name: firstName,
                    last_name: lastName,
                    mode: localStorage.getItem('mode') || 'web',
                    application: webId
                });
                const { token } = response.data;
                if (!token) {
                    throw void 0;
                }

                redirectUrl.searchParams.set('token', token);

                sessionStorage.removeItem('redirect_to_app');
                window.location.replace(redirectUrl.toString());
            })();
        } catch {
            sessionStorage.removeItem('redirect_to_app');
        } finally {
            loader.hide();
        }
    }, [citizenId]);

    //// Check password expiry
    //useEffect(() => {
    //    void (async function () {
    //        const response = await fetch('/v1/password-expiry', {
    //            headers: {
    //                Authorization: `Bearer ${localStorage.getItem('SSO_AUTH')}`
    //            }
    //        });
    //        const data = (await response.json()) as PasswordExpiryWarning;

    //        switch (data.status) {
    //            case 'expired': {
    //                await Swal.fire({
    //                    title: 'Password Expired',
    //                    text: 'Your password has expired. Please change your password.',
    //                    icon: 'warning',
    //                    confirmButtonColor: '#3085d6',
    //                    confirmButtonText: 'Change Password',
    //                    allowOutsideClick: false
    //                });
    //                history.replace('/logout');

    //                break;
    //            }
    //            case 'warn': {
    //                await Swal.fire({
    //                    title: 'Password Expiration Warning',
    //                    text: `Your password will expire in ${data.days_until_password_expires} days. Please change your password.`,
    //                    icon: 'warning',
    //                    allowOutsideClick: false
    //                });

    //                break;
    //            }
    //            default:
    //                break;
    //        }
    //    })();
    //}, []);

    return (
        <>
            {
                //citizenId && (
            //    <RequireChangePasswordFormModal
            //        citizenId={citizenId}
            //        isOpen={isOpenRequireChangePasswordFormModal}
            //        onClose={setIsOpenRequireChangePasswordFormModal.off}
            //    />
                //)
            }

            <Switch>
                <Route
                    path="/login"
                    component={Login}
                />
                <Route
                    path="/invite"
                    component={Invite}
                />
                <Route
                    path="/citizen/editcitizen"
                    component={EditCitizenComponent}
                />
                <Route
                    path="/config/callback"
                    component={CallbackComponent}
                />
                <Route
                    path="/logout"
                    component={LogoutComponent}
                />
                <Route
                    path="/ingress"
                    component={ingress}
                />
                <Route
                    path="/line-connect"
                    component={LineConnectView}
                />
                <Dashboard>
                    <PrivateRoute
                        exact
                        path="/"
                        component={Home}
                    />

                    <PrivateRoute
                        path="/platform"
                        component={Platform}
                    />
                    <PrivateRoute
                        path="/application"
                        component={Application}
                    />
                    <PrivateRoute
                        path="/company"
                        component={Company}
                    />
                    <PrivateRoute
                        path="/platform-dashboard"
                        component={PlatformDashboardComponent}
                    />
                    <PrivateRoute
                        path="/user"
                        component={UserComponent}
                    />
                    <PrivateRoute
                        path="/company-dashboard"
                        component={CompanyDashboardComponent}
                    />
                    <PrivateRoute
                        path="/ticket"
                        component={TicketView}
                    />

                    {/* Deprecated */}
                    <PrivateRoute
                        path="/user-dashboard"
                        component={UserDashboardComponent}
                    />
                    <PrivateRoute
                        path="/platform-register"
                        component={PlatformComponent}
                    />
                    <PrivateRoute
                        path="/user-support"
                        component={UserSupportComponent}
                    />
                    <PrivateRoute
                        path="/user-register"
                        component={UserRegistration}
                    />
                    <PrivateRoute
                        path="/user-verify"
                        component={UserVerification}
                    />
                    <PrivateRoute
                        path="/user-authentication"
                        component={UserAuthentication}
                    />
                    <PrivateRoute
                        path="/feed-task"
                        component={FeedTask}
                    />
                    <PrivateRoute
                        path="/user-applications-redesign"
                        component={UserApplications}
                    />
                    <PrivateRoute
                        path="/client-system-program"
                        component={ClientSystemDownload}
                    />
                    <PrivateRoute
                        path="/scg-client-system-program"
                        component={ClientSystemDownloadSCG}
                    />
                    <PrivateRoute
                        path="/sandbox-register"
                        component={SandboxRegister}
                    />
                    <PrivateRoute
                        path="/assign-role-profile"
                        component={AssignRoleProfile}
                    />
                    <PrivateRoute
                        path="/assign-employee"
                        component={AssignEmployee}
                    />
                    <PrivateRoute
                        path="/new-task"
                        component={NewTask}
                    />
                    <PrivateRoute
                        path="/password-management"
                        component={PasswordManagement}
                    />
                    <PrivateRoute
                        path="/privacy-config"
                        component={PrivacyConfig}
                    />
                    <PrivateRoute
                        path="/fgui-port-management"
                        component={FguiPortManagement}
                    />
                    <PrivateRoute
                        path="/report-log"
                        component={Logs}
                    />
                    <PrivateRoute
                        path="/profile"
                        component={Profile}
                    />
                    <PrivateRoute
                        path="/authentication-history"
                        component={AuthenticationHistoryLogs}
                    />
                    <PrivateRoute
                        path="/application-history"
                        component={ApplicationHistory}
                    />
                    <PrivateRoute
                        path="*"
                        component={NotFound}
                    />
                </Dashboard>
            </Switch>
        </>
    );
});

export default Layout;
